// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.role-checkbox[data-v-bcc82bb2] {\n  margin: 0;\n  margin-bottom: -26px;\n  padding: 0;\n}\n.role-checkbox *[data-v-bcc82bb2] {\n  margin: 0;\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
